import { useState, useEffect, useMemo } from 'react'
import { useNavigate, useLocation, matchPath } from 'react-router-dom'
import { observer } from 'mobx-react'
import { ConfigProvider, Menu } from 'antd'
import { EasyIcon, Scrollbars } from 'src/components'
import { mainStore } from 'enasops/stores'
import { $consts, $evt } from 'src/plugins'
import 'enasops/styles/layout/sider.less'

const generateItemsMenu = (menus: any[], items: any[]) => {
  menus.forEach((menu: any) => {
    const { Node, Children } = menu
    const item: any = {
      key: Node.ID,
      label: <span title={Node.NAME} className='ant-menu-title-content'>{Node.NAME}</span>,
      icon: <EasyIcon type={Node.ICON} defaultIcon='FileTextOutlined' iconSource={require('enasops/styles/fonts/iconfont.json')} />,
      popupClassName: 'custom-scrollbar'
    }
    items.push(item)
    if (Array.isArray(Children) && Children.length) {
      item.children = []
      generateItemsMenu(Children, item.children)
    }
  })
}

const Sider = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [collapsed, setCollapsed] = useState(false)
  const handleCollapseChange = () => {
    const val = !collapsed
    setCollapsed(val)
    $evt.emit($consts['EVT/SIDER_COLLAPSED'], val)
  }

  const handleClick = (evt: any) => {
    const { flatMenus } = mainStore
    const menu = flatMenus.find((item: any) => item.ID === evt.key)
    if (menu) {
      const matchMain = matchPath({
        path: $consts['ROUTE/MAIN'],
      }, location.pathname)

      if (matchMain?.params.menuId === menu.ID) {
        menu.IS_CLICK_RELOAD && navigate(0)
      } else {
        navigate(`/main/${menu.ID}`)
      }
    }
  }

  const theme = useMemo(() => ({
    token: {
      motionDurationSlow: '0s',
    },
    components: {
      Menu: {
        darkItemColor: '#C4C4C4',
        darkItemBg: '#3C4562',
        darkItemSelectedBg: '#5D6787',
        darkItemSelectedColor: '#FFFFFF',
        darkSubMenuItemBg: '#333A4F',
        itemHeight: 52,
        fontSize: 18,
        itemBorderRadius: 0,
        itemMarginInline: 0
      }
    }
  }), [])

  const itemsMenu = useMemo(() => {
    const menus: any[] = []
    generateItemsMenu(mainStore.menus, menus)
    return menus
  }, [mainStore.menus])

  const [selectedKeys, setSelectedKeys] = useState<string[]>([])
  useEffect(() => {
    const matchMain = matchPath({
      path: $consts['ROUTE/MAIN'],
    }, location.pathname)

    setSelectedKeys([matchMain?.params?.menuId ?? ''])
  }, [location.pathname, itemsMenu])

  return (
    <div className='sider'>
      <div className='sider__header'>
        <div
          onClick={handleCollapseChange}
          className={`sider__header-collapse ${collapsed ? 'rotate' : ''}`}
        >
          <img alt='' src={require('enasops/assets/layout/double-left.png')} />
        </div>
      </div>
      <div className='sider__menu'>
        <Scrollbars autoHide>
          <ConfigProvider theme={theme}>
            <Menu
              theme='dark'
              mode='inline'
              inlineCollapsed={collapsed}
              items={itemsMenu}
              selectedKeys={selectedKeys}
              onClick={handleClick}
            />
          </ConfigProvider>
        </Scrollbars>
      </div>
    </div>
  )
}

export default observer(Sider)